import React,{ useState,useRef , useContext} from "react";
import "../../sass/components/common/_otp_modal.scss";
import { map } from "rxjs/operators"
import { useNavigate } from "react-router-dom";
import { AppStateContext } from "../../contexts/AppStateContext";
import ApiService from "../../services/api.service";
import Loader from '../common/Loader'
import ErrMapper from '../common/ErrMapper'
import { useDispatch } from "react-redux";
import { addUserDetails } from "../../store/actions/saveUserCredentials";
import {getMaskedPhone} from '../common/Utils'
import { toggleMenu } from '../../store/actions/MenuAction'
import { useEffect } from "react";
import { digitValidate } from "../post_login/summary";
const OTPModal = ({  userCredentials, setValidationDetails, validationDetails, userName, modalVisible, setModalVisible, action, setPage, passWord }) => {
    const [otp1, setOtp1] = useState('')
    const [otp2, setOtp2] = useState('')
    const [otp3, setOtp3] = useState('')
    const [otp4, setOtp4] = useState('')
   
    const [loader, showLoader] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const ref_input1 = useRef();
    const ref_input2 = useRef();
    const ref_input3 = useRef()
    const ref_input4 = useRef();
    const { handleAuthenticateUser } = useContext(AppStateContext);
    const loginOtp = otp1 + otp2 + otp3 + otp4;
    const OTP_DELAY = 30
    const handleConfirmOtp = (e) => {
        // e.preventDefault();
        showLoader(true);
        setError('')
        const payload = {
            "username": userName,
            "otp": otp1 + otp2 + otp3 + otp4
        }
        const subscription = ApiService.post("/auth/validate_otp",payload).pipe(
            map((res) => {
                showLoader(false)
                if (res.data?.valid !== undefined && res.data.valid === true) {
                    setModalVisible(false)
                    if (validationDetails.firstLogin) {
                        setPage("password")
                    } else {
                        handleAuthenticateUser(true);
                        dispatch(addUserDetails(userCredentials))
                        dispatch(toggleMenu('hidden'))
                        if (userCredentials.Type === "ADMIN") {
                            navigate("/admin-dashboard")
                        } else {
                            navigate("/verify") 
                        }
                    }
                } else if (!res.data?.valid) {
                    setError(res.data.message);
                    ref_input4.current.focus()
                } else {
                    setError("Connection error")
                }

              
          })).subscribe(() => {                            
          });                           
          return () => {
          //   subscription.unsubscribe();                           
          };
        
    }

    const [timeleft, setTimeLeft] = useState(OTP_DELAY)
    useEffect(() => {
        if (timeleft >= 1) {
            const interval = setInterval(() => {
                setTimeLeft((t) => t - 1) 
            }, 1000)
            return () => clearInterval(interval);
            }
            return () => clearInterval(0);

    }, [timeleft])  
        
    const resendOtp = () => {
        setError('')
        setTimeLeft(OTP_DELAY)
        const payload = {
            username: userName,
            password: passWord
        }
        showLoader(true)
        ApiService.post("/auth/send_otp", payload).subscribe((res) => {
            if (res.status === 200) {
                showLoader(false)
            }
        })
    }
   



    
    return <div className="otp-modal">
        <Loader loader={loader}/>
        <div className="otp-overlay"/>
        <div className="otp-container">
            <span onClick={()=>{setModalVisible(false)}} className="close-btn">
            <svg id="icon-clear" viewBox="0 0 24 24" style={{
                fill: '#000',
                height: '3rem',
                width: '2.3rem'
            }}>
                <path d="M18.984 6.422l-5.578 5.578 5.578 5.578-1.406 1.406-5.578-5.578-5.578 5.578-1.406-1.406 5.578-5.578-5.578-5.578 1.406-1.406 5.578 5.578 5.578-5.578z"></path>
            </svg>
            </span>
            <h1 className="otp-header">OTP verification</h1>
            <p>An SMS with a verification code has been sent to <strong style={{color:"#000", fontFamily:"Noto-Bold"}}> { getMaskedPhone(userCredentials.PhoneNumber) }</strong></p>
            <p>Please enter the code to proceed.</p>
            <form className="otp-form">
                <input className="otp" inputMode="numeric" type="text" ref={ref_input1} onInput={(e) => { digitValidate(e) }} onChange={(values) => { setOtp1(values.target.value); setError(''); }} onKeyUp={(e) => {
                    if (ref_input1.current.value != '') {
                        ref_input2.current.focus()
                    }


                }} maxLength='1' />
                <input className="otp" inputMode="numeric" type="text" ref={ref_input2} onInput={(e) => { digitValidate(e) }} onChange={(values) => { setOtp2(values.target.value); setError(''); }} onKeyUp={(e) => {
                    if (ref_input2.current.value !== '' && e.key !== "Backspace") {
                        ref_input3.current.focus()
                    } else if (e.key === "Backspace") {
                        ref_input1.current.focus()
                    }
                }} maxLength='1' />
                <input className="otp" inputMode="numeric" type="text" ref={ref_input3} onInput={(e) => { digitValidate(e) }} onChange={(values) => { setOtp3(values.target.value); setError(''); }} onKeyUp={(e) => {
                    if (ref_input3.current.value !== '' && e.key !== "Backspace") {
                        ref_input4.current.focus()
                    } else if (e.key === "Backspace") {
                        ref_input2.current.focus()
                    }
                }} maxLength='1' />
                <input className="otp" inputMode="numeric" type="text" ref={ref_input4} onInput={(e) => { digitValidate(e) }} onChange={(values) => { setOtp4(values.target.value); setError(''); }} onKeyUp={(e) => {
                    if (ref_input4.current.value !== '' && e.key !== "Backspace") {
                        console.log(loginOtp)
                        ref_input4.current.blur();
                    } else if (e.key === "Backspace") {
                        ref_input3.current.focus()
                    }
                }} maxLength='1' />

            </form>
            <div className="center-content">
               <ErrMapper err={error} />
            </div>
            
            
            <div className={`regenerate-otp ${timeleft === 0 ? '': 'disabled'}`} onClick={() => {resendOtp() }}>Resend OTP</div>
         
            {
                (!timeleft <= 0) ?
                    <p className={`resend-otp ${timeleft <= 0 ? '' : 'resend-otp disabled'}`} style={{ marginTop: '', cursor: 'pointer' }} onClick={() => { resendOtp() }}>
                    <u style={{ fontFamily: 'Noto-Bold' }}> Didn't receive OTP? Resend
                        {(!timeleft <= 0) ? <b className="counter"> in {timeleft}sec</b> : ' now'}</u>
                </p>
                :<></>
            }
            
            
            <div className="otp_button_container">
                <button className="back" onClick={(e) => { e.preventDefault(); setModalVisible(false) }} type="submit">Back</button>
                <button  className={`confirm ${loginOtp.length===4 ? '' : 'disabled-btn' }`} onClick={handleConfirmOtp}>Confirm</button>
            </div>
        </div>
    </div>
}

export default OTPModal
